import React, { useEffect, useState, useCallback } from "react";
import * as Sentry from "@sentry/react";
import { usePlaidLink } from "react-plaid-link";

import {
  createProviderLinkOnFailure,
  createProviderLinkOnClose,
  createProviderLinkOnSuccess,
} from "../../helpers/webViewCallback";

import { callBackendAPI } from "../../helpers/api";

const PlaidProvider = ({ providerData, mode, walletId }) => {
  const [linkTokenData, setLinkTokenData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  console.log(providerData, "providerData");

  useEffect(() => {
    window.analytics.track("provider_link_plaid_page_view");
  }, []);

  const generateToken = async () => {
    //TODO: add cutomisation of link type
    setIsLoading(true);
    const createLinkTokenRes = await callBackendAPI({
      path: `/provider_link/plaid/create_link_token?provider_id=${providerData.id}`,
      method: "GET",
    });

    setLinkTokenData(createLinkTokenRes);
    if (window.flutter_inappwebview) {
      window.flutter_inappwebview.callHandler(
        "plaidLinkTokenRes",
        createLinkTokenRes
      );
      localStorage.setItem(
        "plaid_link_token",
        JSON.stringify(createLinkTokenRes)
      );
    } else {
      localStorage.setItem(
        "plaid_link_token",
        JSON.stringify(createLinkTokenRes)
      );
    }

    console.log({ createLinkTokenRes });
  };

  const generateRefreshToken = async () => {
    //TODO: add cutomisation of link type
    setIsLoading(true);
    // const walletId = localStorage.getItem("api_token")
    const createLinkTokenRes = await callBackendAPI({
      path: `/provider_link/plaid/create_refresh_link_token`,
      method: "POST",
      body: {
        user_wallet_id: walletId,
      },
    });

    setLinkTokenData(createLinkTokenRes);
    if (window.flutter_inappwebview) {
      window.flutter_inappwebview.callHandler(
        "plaidLinkTokenRes",
        JSON.stringify(createLinkTokenRes)
      );
      localStorage.setItem(
        "plaid_link_token",
        JSON.stringify(createLinkTokenRes)
      );
    } else {
      localStorage.setItem(
        "plaid_link_token",
        JSON.stringify(createLinkTokenRes)
      );
    }

    console.log({ createLinkTokenRes }, "refresh");
  };

  const onSuccess = useCallback(async (public_token, metadata) => {
    // TODO - handle type here
    const plaidlinktokenresp = JSON.parse(
      localStorage.getItem("plaid_link_token")
    );
    setLinkTokenData(plaidlinktokenresp);
    if (mode === "fix") {
      const createItemRes = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/provider_link/fix_link`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("api_token")}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            link_id: plaidlinktokenresp.link_id,
            link_type: providerData.wallet_type,
            public_token: public_token,
            link_token: plaidlinktokenresp.link_token,
          }),
        }
      );
      const data = await createItemRes.json();

      window.analytics.track("provider_link_success", {
        source: "plaid_provider_account_fix",
        target: "providerLink",
        link_id: plaidlinktokenresp.link_id,
        providerData,
      });

      createProviderLinkOnSuccess({
        message: "Account fixed successfully",
      });
    } else {
      const createItemRes = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/provider_link/create_link`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("api_token")}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            link_type: providerData.wallet_type,
            provider_id: providerData.id,
            public_token: public_token,
            subtype: "",
            address: "",
            access_token: "",
          }),
        }
      );
      const data = await createItemRes.json();

      if (data && data.user_wallet_id) {
        createProviderLinkOnSuccess({
          message: "Account created successfully",
          walletId: data.user_wallet_id,
        });
        window.analytics.track("provider_link_success", {
          source: "plaid_provider_account_create",
          target: "providerLink",
          walletId: data.user_wallet_id,
        });
      }
    }
  }, []);

  useEffect(() => {
    if (!isLoading) {
      if (mode === "fix") {
        window.analytics.track(
          "provider_link_plaid_provider_generate_refresh_token",
          {
            target: "providerLink",
            mode,
          }
        );
        generateRefreshToken();
      } else {
        window.analytics.track("provider_link_plaid_provider_generate_token", {
          target: "providerLink",
          mode,
        });
        generateToken();
      }
    }
  }, [isLoading, mode]);

  console.log(linkTokenData, "linkTokenData");

  const config = {
    token: linkTokenData && linkTokenData.link_token,
    receivedRedirectUri: null,
    onSuccess,
    onEvent: async (eventName, metaData) => {
      console.log(eventName, metaData);

      if (eventName === "ERROR") {
        console.log(linkTokenData);
        window.analytics.track("provider_link_plaid_provider_report_error", {
          target: "providerLink",
          providerData: providerData,
          eventName,
          metaData,
        });
        const sendError = await callBackendAPI({
          path: `/provider_link/plaid/report_error?provider_id=${providerData.id}`,
          method: "POST",
          body: {
            link_token: linkTokenData?.link_token,
            error_data: {
              ...metaData,
            },
          },
        });
      }
    },
    onExit: useCallback(async (err, metadata) => {
      if (!window.flutter_inappwebview) {
        console.log({ err }, { metadata });
        Sentry.captureException(metadata);
        if (err) {
          Sentry.captureException(err);
          createProviderLinkOnFailure(
            "Something went wrong, please contact support"
          );
          window.analytics.track("provider_link_failure", {
            source: "plaid_provider_exit_error",
            target: "providerLink",
            err,
            metadata,
          });
        } else {
          createProviderLinkOnClose(
            "Couldn't connect account, please try again"
          );
          window.analytics.track("provider_link_failure", {
            source: "plaid_provider_exit",
            action: "exit",
            target: "providerLink",
            err,
            metadata,
          });
        }
      }
    }),
  };

  const { open, ready } = usePlaidLink(config);

  if (linkTokenData !== null && ready) {
    open();
  }
  return <div></div>;
};

export default PlaidProvider;
